import z from 'zod';
import { userIdValue } from '../../subscription/value-objects/ids';
import { calendarFeedTokenValue, userCalendarIdValue, } from '../value-objects/ids';
import { userCalendarEventSchema } from '../value-objects/user-calendar-event';
export const userCalendarSchema = z.object({
    events: z.array(userCalendarEventSchema),
    feedToken: calendarFeedTokenValue.optional(),
    id: userCalendarIdValue,
    revision: z.number().int().nonnegative(),
    userId: userIdValue,
});
export const parseUserCalendar = (value) => userCalendarSchema.parse(value);
export const isUserCalendar = (value) => userCalendarSchema.safeParse(value).success;
//# sourceMappingURL=user-calendar.js.map